(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.qty-btn').forEach((button) => {
    button.addEventListener('click', () => {
      const input = document.getElementById(button.dataset.target);
      if (!input) return;
      const current = Number.parseInt(input.value || '0', 10);
      const step = Number.parseInt(button.dataset.step || '0', 10);
      input.value = Math.max(0, current + step);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="Product-"]').forEach((root) => {
    const variantSelect = root.querySelector('.product-variant-select');
    const optionGroups = Array.from(root.querySelectorAll('.product-option-values'));
    const price = root.querySelector('.product-price');
    const comparePrice = root.querySelector('.product-compare-price');
    const addButton = root.querySelector('.product-add-button');
    const mainImage = root.querySelector('.product-main-image');
    const thumbnails = Array.from(root.querySelectorAll('.product-thumbnail'));

    if (!variantSelect) return;

    const variants = Array.from(variantSelect.options).map((option) => {
      let values = [];
      try {
        values = JSON.parse(option.dataset.options || '[]');
      } catch (error) {
        values = [];
      }
      return {
        element: option,
        values,
        available: option.dataset.available === 'true'
      };
    });

    const selectedValues = () => optionGroups.map((group) => {
      const selected = group.querySelector('.product-option-button.is-selected');
      return selected ? selected.dataset.optionValue : '';
    });

    const setActiveThumbnail = (url) => {
      if (!url) return;
      thumbnails.forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.imageUrl === url);
      });
    };

    const updateOptionAvailability = () => {
      const current = selectedValues();

      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('.product-option-button').forEach((button) => {
          const candidate = [...current];
          candidate[groupIndex] = button.dataset.optionValue;

          const possible = variants.some((variant) => {
            if (!variant.available) return false;
            return variant.values.every((value, index) => {
              if (index === groupIndex) return value === candidate[index];
              return !candidate[index] || value === candidate[index];
            });
          });

          button.disabled = !possible;
          button.setAttribute('aria-disabled', possible ? 'false' : 'true');
        });
      });
    };

    const updateVariant = () => {
      const values = selectedValues();
      const match = variants.find((variant) =>
        JSON.stringify(variant.values) === JSON.stringify(values)
      );

      updateOptionAvailability();
      if (!match) return;

      variantSelect.value = match.element.value;

      if (price && match.element.dataset.price) {
        price.textContent = match.element.dataset.price;
      }

      if (comparePrice) {
        comparePrice.textContent = match.element.dataset.comparePrice || '';
        comparePrice.hidden = !match.element.dataset.comparePrice;
      }

      if (mainImage && match.element.dataset.image) {
        mainImage.src = match.element.dataset.image;
        mainImage.srcset = '';
        setActiveThumbnail(match.element.dataset.image);
      }

      if (addButton) {
        addButton.disabled = !match.available;
        addButton.textContent = match.available
          ? addButton.dataset.availableLabel || 'Ajouter au panier'
          : addButton.dataset.soldOutLabel || 'Épuisé';
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.element.value);
      window.history.replaceState({}, '', url);
    };

    optionGroups.forEach((group) => {
      group.querySelectorAll('.product-option-button').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;

          group.querySelectorAll('.product-option-button').forEach((other) => {
            const selected = other === button;
            other.classList.toggle('is-selected', selected);
            other.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });

          updateVariant();
        });
      });
    });

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (mainImage && thumb.dataset.imageUrl) {
          mainImage.src = thumb.dataset.imageUrl;
          mainImage.srcset = '';
          setActiveThumbnail(thumb.dataset.imageUrl);
        }
      });
    });

    updateVariant();
  });
});

  } catch(e) { console.error(e); }
})();
})();
